// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// production logging server

export const environment = {
  production: false,
  evoApi: 'https://api.evolytes.io',
  /** evoApi: 'http://localhost:3000', **/
  // evoApi: 'https://evolytes-api.herokuapp.com',
  downloadURL: 'https://api.evolytes.io/thankpurchase',
  cbSite: 'evolytes-test',
  recaptchaV3Key: '',
  recaptchaV2Key: '6LdFyq0pAAAAAL0bOQjrmRUsLKOG3JBULF7LmgPp',
  droppURL: 'https://api.dropp.is'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
